exports = module.exports = require("../../../../css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._1L1YNWB5kH730wqzaNJ-it{width:100%;font-size:12px}html[dir] ._1L1YNWB5kH730wqzaNJ-it{margin-top:20px;text-align:center}._3a2PWRiVY0z5N3W5aHYgNp{width:100%;font-size:12px}html[dir] ._3a2PWRiVY0z5N3W5aHYgNp{margin-top:8px}html[dir=ltr] ._3a2PWRiVY0z5N3W5aHYgNp{text-align:right}html[dir=rtl] ._3a2PWRiVY0z5N3W5aHYgNp{text-align:left}", ""]);
// Exports
exports.locals = {
	"systemMessage": "_1L1YNWB5kH730wqzaNJ-it",
	"errorMessage": "_3a2PWRiVY0z5N3W5aHYgNp"
};